// Numero di email non lette su favicon, titolo della scheda e icona dell'app installata (PWA)
const ICON = process.env.PUBLIC_URL + "/posta-ai-icon.png";
let base = null;
let ultimo = "";

function iconLink() {
  let l = document.querySelector('link[rel="icon"]');
  if (!l) {
    l = document.createElement("link");
    l.rel = "icon";
    document.head.appendChild(l);
  }
  return l;
}

function caricaBase() {
  if (base) return Promise.resolve(base);
  return new Promise((ok) => {
    const img = new Image();
    img.onload = () => { base = img; ok(img); };
    img.onerror = () => ok(null);
    img.src = ICON;
  });
}

// n = non lette totali; pec = true se tra queste c'è almeno una PEC vera (non ricevute) → favicon rosso
export async function aggiornaBadge(n, pec = false) {
  n = Math.max(0, n | 0);
  const chiave = `${n}|${pec ? 1 : 0}`;
  if (chiave === ultimo) return;
  ultimo = chiave;
  document.title = n > 0 ? `(${n}) POSTA AI` : "POSTA AI";
  try {
    if (navigator.setAppBadge) n > 0 ? await navigator.setAppBadge(n) : await navigator.clearAppBadge();
  } catch (e) {
    console.debug("badge app non supportato", e);
  }
  const img = await caricaBase();
  if (n === 0 || !img) {
    iconLink().href = ICON;
    return;
  }
  const S = 64;
  const c = document.createElement("canvas");
  c.width = S; c.height = S;
  const ctx = c.getContext("2d");
  ctx.drawImage(img, 0, 0, S, S);
  if (pec) {
    // PEC non letta: l'icona diventa rossa (colore sovrapposto solo dove l'icona è disegnata)
    ctx.globalCompositeOperation = "source-atop";
    ctx.fillStyle = "rgba(211, 47, 47, 0.82)";
    ctx.fillRect(0, 0, S, S);
    ctx.globalCompositeOperation = "source-over";
  }
  const testo = n > 99 ? "99+" : String(n);
  const r = 17;
  const cx = S - r - 1, cy = r + 1;
  ctx.beginPath();
  ctx.arc(cx, cy, r, 0, Math.PI * 2);
  ctx.fillStyle = pec ? "#fff" : "#e53935";
  ctx.fill();
  ctx.lineWidth = 3;
  ctx.strokeStyle = pec ? "#b71c1c" : "#fff";
  ctx.stroke();
  ctx.fillStyle = pec ? "#b71c1c" : "#fff";
  ctx.font = `bold ${testo.length > 2 ? 15 : 20}px Arial, sans-serif`;
  ctx.textAlign = "center";
  ctx.textBaseline = "middle";
  ctx.fillText(testo, cx, cy + 1);
  iconLink().href = c.toDataURL("image/png");
}
